import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import { UserFirstCustomerReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import UserFirstCustomerReportsFilter from "./UserFirstCustomerReportsFilter";
import { convertDate } from "../../../utils/convertDate";

export default function UserFirstCustomerReports() {
  const [reportsData, setReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/reports/getFirstTimeCustomersWithOrdersInRange";
    try {
      const response = await getApi({ path, params: { ...params } });
      const result = response?.data?.result || [];
      setReportsData(convertData(result));
    } catch (error) {
      console.log(error);
    }
  };
  const convertData = (result) => {
    const convertResult = result.map((item) => {
      item.paymentDate = convertDate(item.paymentDate);
      item.user = item.user?.name;
      item.userMobile = item.user?.mobile;
      item.userRole = item?.userRole;
      return item;
    });
    return convertResult;
  };

  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"خرید اولی ها"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={reportsData || []} />
        </div>
      </div>
      <UserFirstCustomerReportsFilter filterDataHandler={filterDataHandler} />
      <Table
        columns={UserFirstCustomerReportsColumns}
        rows={reportsData || []}
      />
    </div>
  );
}
